/*
 *
 * UsersDetail actions
 *
 */

import {
  FLUSH_STATE,
  LOAD_USER,
  LOAD_USER_SUCCESS,
  LOAD_USER_ERROR,
  CHANGE_USER,
  CHANGE_USER_SUCCESS,
  CHANGE_USER_ERROR,
} from './constants';

export function flushState() {
  return {
    type: FLUSH_STATE,
  };
}

/**
 * Load the users, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_USERS */

export function loadUser(id) {
  return {
    type: LOAD_USER,
    id,
  };
}

/**
 * Dispatched when the loadUsers are loaded by the request saga
 *
 * @param  {array} User true for users
 *
 * @return {object}      An action object with a type of LOAD_USERS_SUCCESS passing the Users */

export function loadUserSuccess(userData) {
  return {
    type: LOAD_USER_SUCCESS,
    userData,
  };
}

/**
 * Dispatched when loading the loadUsers fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_USERS_ERROR passing the error */

export function loadUserError(error) {
  return {
    type: LOAD_USER_ERROR,
    error,
  };
}
